import { ParameterTypeEnum } from "@commons/enums/parameter-type.enum";
import { IAxisConfig } from "@src/app/interfaces/chart-params.interface";
import { numberFormatter } from "@src/app/utils/numbers";

export interface IYAxisConfigBuilder {
    buildYAxisConfig(data: IAxisConfig[], theBiggestNumberInChart: number): any[];
}

export class YAxisConfigBuilderCarsParams implements IYAxisConfigBuilder {

    public buildYAxisConfig(data: IAxisConfig[], theBiggestNumberInChart: number): any[] {
        if (!data.length) {
            return [{ type: 'value', show: false, }];
        }

        let leftCount = 0;
        let rightCount = 0;

        return data.map(({ y: item }, index) => {
            if (item.show === false) {
                return {
                    type: 'value',
                    show: false,
                    max: theBiggestNumberInChart,
                    min: 0,
                }
            }

            const position = leftCount <= rightCount ? 'left' : 'right';

            let offset = 0;
            if (position === 'left') {
                if (leftCount === 1) {
                    offset = 60;
                }
                leftCount++;
            } else {
                if (rightCount === 1) {
                    offset = 72;
                }
                rightCount++;
            }

            return {
                type: item.type,
                name: item.name,
                position,
                offset,
                alignTicks: true,
                show: true,
                nameTruncate: {
                    maxWidth: 60,
                },
                axisLine: {
                    show: item.axisLineShow,
                    lineStyle: {
                        color: item.color,
                    },
                },
                axisLabel: {
                    formatter: (value: number) => numberFormatter.format(value) + ' ' + (item.unit || ''),
                    show: item.typeParameter !== ParameterTypeEnum.Binary,
                },
                nameTextStyle: {
                    align: position === 'left' ? 'right' : 'left',
                    fontSize: 12,
                },
                scale: item.typeParameter === ParameterTypeEnum.Voltage ? true : undefined,
                boundaryGap: item.typeParameter === ParameterTypeEnum.Voltage ? [0, '5%'] : undefined,
            };
        });
    }
}
